import ChangePassword from '@/apps/ChangePassword/components'
import React from 'react'

const ChangePasswordBody = (): React.ReactElement => {
  return <ChangePassword />
}

export default ChangePasswordBody
